import { http } from '../axios';
import { shopPrefix } from '../../config';
import { BundleCategoryResponse } from '../../shop/language/bundles/bundleCategories';

type Params = {
    loanFormat: string;
    ageCategory?: string;
};

const url = `${shopPrefix}/v1/bundles/:loanFormat/categories`;

export const fetchBundleCategories = ({ loanFormat, ageCategory }: Params) => {
    return http
        .get<BundleCategoryResponse>(url, {
            pathParams: {
                loanFormat
            },
            params: {
                ageCategory
            }
        })
        .then(res => res.data);
};
